<template>
  <AddCareer />
</template>
<script>
import appConfig from '@/app.config'
import AddCareer from '../../../components/skillup/careers/AddCareer.vue'
export default {
  page: {
    title: 'ثبت شغل',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-add-careers',
  components: {
    AddCareer,
  },
}
</script>
